import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import * as Routes from 'constants/routes';
import './index.scss';

const StripNavLink = (props) => {
    const { id, text, icon, path, active } = props;
    
    const mainClass = path === '' ? "main":"";
    return (
    <NavLink 
        to={Routes.magazine + path} 
        className={`strip-nav-link-wrapper`}
        activeClassName={active ? "active":""}
    >
        {icon && <img src={icon} alt="" className={`nav-link-icon ${mainClass}`} />}
        {text}
    </NavLink>);
}

export default StripNavLink;